import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_2'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_2',
  name: "Which of the following topics are included within the facility's written policies and procedures for the prohibition of forced labor?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PROHIBITION_OF_FORCED_LABOR',
      text: 'Prohibition of forced labor',
      externalIds: [
        {
          id: 'ms-1--4-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROHIBITION_OF_BONDED_LABOR',
      text: 'Prohibition of bonded labor',
      externalIds: [
        {
          id: 'ms-1--4-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROHIBITION_OF_INDENTURED_LABOR',
      text: 'Prohibition of indentured labor',
      externalIds: [
        {
          id: 'ms-1--4-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROHIBITION_OF_PRISON_LABOR',
      text: 'Prohibition of prison labor',
      externalIds: [
        {
          id: 'ms-1--4-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROHIBITION_OF_HUMAN_TRAFFICKING',
      text: 'Prohibition of human trafficking',
      externalIds: [
        {
          id: 'ms-1--4-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VOLUNTARY_EMPLOYMENT',
      text: 'Voluntary employment',
      externalIds: [
        {
          id: 'ms-1--4-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VOLUNTARY_OVERTIME',
      text: 'Voluntary overtime',
      externalIds: [
        {
          id: 'ms-1--4-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FREEDOM_OF_MOVEMENT',
      text: 'Freedom of movement',
      externalIds: [
        {
          id: 'ms-1--4-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VOLUNTARY_END_OF_EMPLOYMENT',
      text: 'Voluntary end of employment',
      externalIds: [
        {
          id: 'ms-1--4-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ETHICAL_RECRUITMENT_USE_OF_EMPLOYMENT_AGENCIES_RECRUITERS_AND_O',
      text: 'Ethical recruitment/ use of employment agencies, recruiters, and/or labor agents',
      externalIds: [
        {
          id: 'ms-pla-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'STATE_IMPOSED_FORCED_LABOR_GOVERNMENT_MANDATED_FORCED_LABOR',
      text: 'State-imposed forced labor/ Government-mandated forced labor',
      externalIds: [
        {
          id: 'ms-pla-14x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--4-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--4-10f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PROHIBITION_OF_FORCED_LABOR',
                'PROHIBITION_OF_BONDED_LABOR',
                'PROHIBITION_OF_INDENTURED_LABOR',
                'PROHIBITION_OF_PRISON_LABOR',
                'PROHIBITION_OF_HUMAN_TRAFFICKING',
                'VOLUNTARY_EMPLOYMENT',
                'VOLUNTARY_OVERTIME',
                'FREEDOM_OF_MOVEMENT',
                'VOLUNTARY_END_OF_EMPLOYMENT',
                'ETHICAL_RECRUITMENT_USE_OF_EMPLOYMENT_AGENCIES_RECRUITERS_AND_O',
                'STATE_IMPOSED_FORCED_LABOR_GOVERNMENT_MANDATED_FORCED_LABOR',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-12',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 18860,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
